import { useQuery } from '@apollo/react-hooks';
import { FormInput, FormInputProps } from 'modules';
import { TariffListQuery } from 'queries/Tariff/Tariff';
import React from 'react';

interface TariffSelectProps extends FormInputProps {
  outputValue?: (data: GQL.ITariff) => number;
}

const TariffSelect = (props: TariffSelectProps) => {
  const { data, loading } = useQuery(TariffListQuery, {
    variables: {
      where: {
        active: true,
      },
    },
  });

  const getOptions = () => {
    if (data && data.tariffList) {
      return data.tariffList
        .filter((s: GQL.ITariff) => s.kod?.substr(0, 1) !== '_')
        .map((s: GQL.ITariff) => ({
          label: s.kod,
          value: s.id,
        }));
    }

    return [];
  };

  const onChange = (e: React.ChangeEvent) => {
    if (props.onChange) {
      const { name, value } = e.target as HTMLInputElement;
      const tariff = data?.tariffList?.find((b: GQL.ITariff) => b.id === parseInt(value, 10));
      if (props.outputValue) {
        props.onChange({
          target: {
            name,
            value: props.outputValue(tariff),
          },
        });
      } else {
        props.onChange(e);
      }
    }
  };

  return (
    <FormInput
      {...props}
      type="select"
      placeholder={loading ? 'Načítám ...' : 'Vyberte ...'}
      disabled={props.disabled || loading}
      options={getOptions()}
      onChange={onChange}
    />
  );
};

export default TariffSelect;
